import { html, SYSBaseElement } from "../../../../../_ovlclient/src"
import type { SYSTableDefIds } from "../../../../../_ovlclient/src"
import { DialogClose } from "../../../../../_ovlclient/src/library/dialog/dialogapi"
import type { DialogHolderParams } from "../../../../../_ovlclient/src/library/dialog/dialogapi"
import { T } from "../../../../../_ovlclient/src/textapi"
import { NavDef } from "../../../../../_ovlclient/src/library/table/navcontrol"

export class DialogSYSUserAdministrationCompany extends SYSBaseElement {
  async init() {
    this.dialog = "SYSUserAdministration_Company"
    await super.init()
  }
  async getUI() {
    let dialogHolderParams: DialogHolderParams
    dialogHolderParams = {
      dialogParts: {
        tableDefButtonsInFooter: "SYSUserAdministration_Company",
        dismissedCallbackFn: () => {
          DialogClose(this.dialog)
        },
        title: () => T("SYSUserAdministrationCompanyTitle"),
        body: () => html`<ovl-table
          class="fd-table fd-table--no-horizontal-borders"
          .props=${() => <SYSTableDefIds>"SYSUserAdministration_Company"}
        >
        </ovl-table>`,
      },
      dialogType: this.dialog,
    }
    return html`<ovl-dialogholder
      .dialogHolderParams=${dialogHolderParams}
    ></ovl-dialogholder>`
  }
}
